import { render, staticRenderFns } from "./star-display.vue?vue&type=template&id=448c90f0&"
import script from "./star-display.vue?vue&type=script&lang=js&"
export * from "./star-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('448c90f0')) {
      api.createRecord('448c90f0', component.options)
    } else {
      api.reload('448c90f0', component.options)
    }
    module.hot.accept("./star-display.vue?vue&type=template&id=448c90f0&", function () {
      api.rerender('448c90f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2WFwAkAA1Ffze/JS/comp/star-display.vue"
export default component.exports